import { WorkflowTriggerTypes } from 'src/app/models/RestApiCaller/Enums/workflow-trigger-types';
import { BaseTriggerData } from './base-trigger-data';

/**
 * Représente les données d'un trigger 'Activation d'étape'.
 */
export class StepActivatedTriggerData extends BaseTriggerData {
    /// <summary>
    /// Id de l'étape activée.
    /// </summary>
    public stepId: number = null;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowTriggerTypes.StepActivated);
    }

    /**
     * Retourne une copie d'une instance de StepActivatedTriggerData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: StepActivatedTriggerData) {
        if (!!other) {
            const instance = new StepActivatedTriggerData();
            instance.stepId = other.stepId;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
